import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { DataTokenType } from '../../../types';
import GenericTokenCard from '../GenericTokenCard';
import { TOKEN_TYPES_WITH_LENGTH_CONTROL } from '../LengthControlDrawer';
import DataTokenCardBody, { isDataBodyEmpty } from './DataTokenCardBody';
import DataTypeSelect from './DataTypeSelect';
export default function DataTokenCard(_a) {
    var name = _a.name, index = _a.index, isLast = _a.isLast;
    var type = useField("".concat(name, ".type"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : DataTokenType.NEWLINE; },
    }).input.value;
    var shouldHaveLengthControl = useCallback(function () { return TOKEN_TYPES_WITH_LENGTH_CONTROL.includes(type); }, [type]);
    return (React.createElement(GenericTokenCard, { fieldArrayName: "data", name: name, index: index, isLast: isLast, SelectComponent: DataTypeSelect, BodyComponent: DataTokenCardBody, isBodyEmpty: isDataBodyEmpty, shouldHaveLengthControl: shouldHaveLengthControl }));
}
